module.exports = __webpack_public_path__ + "media/components/assets/recycling_01-cf35282d22b2afe6374c90fe179070b2.jpg";